import React from "react";
import Helmet from "react-helmet";

import Layout from "components/shared/Layout";
import FAQList from "./FAQList";
import CTASection from "../shared/CTASection";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "How much does it cost?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "With PhotoInvoice you can choose between per-invoice pricing or a monthly subscription. Full pricing details can be found on our pricing page.",
      },
    },
    {
      "@type": "Question",
      name: "How long does it take for funds to reach my bank account?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Funds are deposited into your bank account two business days after an invoice has been paid. Note: As an anti-fraud measure, your first payout takes longer than normal, up to 7-10 days.",
      },
    },
    {
      "@type": "Question",
      name: "Can photos be released before payment for trusted clients?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes, every invoice has the option to release assets regardless of payment, or once the invoice has been paid.",
      },
    },
    {
      "@type": "Question",
      name: "Does it handle sales tax?",
      acceptedAnswer: {
        "@type": "Answer",
        text: 'Yes, you can configure your invoices to automatically include a certain percentage as tax, override this value per-invoice, and specify the label used ("Sales Tax", "VAT", etc).',
      },
    },
    {
      "@type": "Question",
      name: "Can I connect PhotoInvoice with a payment provider other than Stripe?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "At this time Stripe is our only payment provider option. Stripe is easy to set up, has the same fees as other providers (Square, PayPal, etc), and offers a great user experience.",
      },
    },
    {
      "@type": "Question",
      name: "What currencies are available?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "PhotoInvoice can be configured to accept US Dollars, Australian Dollars, Canadian Dollars, British Pounds, or Euros.",
      },
    },
    {
      "@type": "Question",
      name: "Can I generate quarterly reports for tax reporting, etc?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes, we offer invoice and revenue reports that should allow you to pull whatever data needed. We are also happy to help create custom reports.",
      },
    },
    {
      "@type": "Question",
      name: "How do sample images and watermarks work?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Sample images are displayed on the unpaid invoice in order to give your client a preview of the shoot. PhotoInvoice automatically watermarks sample images when they are uploaded. By default, samples are watermarked with the word SAMPLE. On the Professional Edition, samples can be watermarked with your custom logo or graphic.",
      },
    },
  ],
};

const FAQPage = () => {
  return (
    <Layout>
      <Helmet title="FAQs | PhotoInvoice">
        <meta
          name="description"
          content="Common questions about PhotoInvoice — pricing, payment timing, currencies, watermarks, sales tax, and more."
        />
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      <h1>FAQs</h1>

      <FAQList />

      <CTASection
        title="Create your first hassle-free invoice"
        subtitle="Test your first invoice in seconds, for free."
      />
    </Layout>
  );
};

export default FAQPage;
